import React from "react";
import { Search, RefreshCw, Plus, X } from "lucide-react";

interface Props {
  search: string;
  setSearch: (value: string) => void;
  showFilters: boolean;
  setShowFilters: (value: boolean) => void;
  loading: boolean;
  handleAddOrder: () => void;
  handleRefresh: () => void;
  themeBorderColor: string;
  themeRingColor: string;
  getBgClass: () => string;
}

const OrderActions: React.FC<Props> = ({ search, setSearch, showFilters, setShowFilters, loading, handleAddOrder, handleRefresh, themeBorderColor, getBgClass, themeRingColor }) => (
  <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
    <div className="relative min-w-80">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
      <input
        type="text"
        placeholder="Search by Order ID or Customer Name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={`w-full bg-gray-50 border border-gray-200 rounded-xl pl-10 pr-4 py-3 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:${themeBorderColor.replace(
          "border",
          "ring"
        )} focus:border-transparent transition-all duration-200`}
      />
       {search && (
          <button
            onClick={() => setSearch("")}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600 transition-colors duration-200"
          >
            <X className="w-6 h-6" />
          </button>
        )}
    </div>

    <div className="flex gap-2">
      <button onClick={handleRefresh} disabled={loading} className="p-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-700 hover:bg-gray-100 disabled:opacity-50">
        <RefreshCw className={`w-5 h-5 ${loading ? "animate-spin" : ""}`} />
      </button>
      <button
        onClick={handleAddOrder}
        className={`flex items-center gap-2 px-4 py-3 bg-gradient-to-r ${getBgClass()} hover:opacity-90 text-white font-semibold rounded-xl transition-all duration-200 shadow-lg ${themeRingColor.replace(
          "ring",
          "shadow"
        )}/25 transform hover:scale-105`}
      >
        <Plus className="w-5 h-5" /> New Order
      </button>
    </div>
  </div>
);

export default OrderActions;
